import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { MediaPlayer, MediaProvider } from '@vidstack/react';

interface VideoDialogProps {
  video: string;
  title: string;
  isVertical?: boolean;
}

export const VideoDialog = ({ title, video, isVertical }: VideoDialogProps): React.ReactElement => (
  <Dialog
    open
    className={`bg-black p-3 border-none shadow-none video-modal grid content-center items-center ${
      isVertical
        ? 'h-fit w-fit max-am-lg:w-[calc(80%)]'
        : 'md:max-w-[calc(90%-2rem)] lg:max-w-[calc(80%-2rem)] xl:max-w-[calc(70%-2rem)]'
    }`}
  >
    <MediaPlayer controls title={title} src={video} aspectRatio={isVertical ? '9/16' : '16/9'}>
      <MediaProvider />
    </MediaPlayer>
  </Dialog>
);
